'use strict';

exports.__esModule = true;
exports.FunctionOrMapChildrenType = undefined;
exports.default = functionOrMapChildren;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var PropTypes = _interopRequireWildcard(_propTypes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function functionOrMapChildren(children, withProps) {
  if (children && children.constructor && children.call && children.apply) {
    return children(withProps) || _react2.default.createElement('div', null, 'Could not render children from function');
  }

  return _react2.default.Children.map(children, function (child) {
    return _react2.default.cloneElement(child, withProps);
  }) || _react2.default.createElement('div', null, 'Could not clone children');
}

var FunctionOrMapChildrenType = exports.FunctionOrMapChildrenType = PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.node), PropTypes.node]);